import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
export const CheckoutConfigurationContext = createContext({
    payOnDelivery: {
        paymentMethod: "",
    },
    zeroValueOrder: {
        userNotification: "",
    },
    loyalty: {
        learnMoreUrl: "",
        orderConfirmationLoyaltyUrl: "",
        redemptionTabSymbol: "",
        showMgm: false,
        showReminderDialog: false,
        reminderDialogTitle: "",
        reminderDialogSubtitle: "",
        reminderDialogText: "",
        reminderDialogSecondaryButtonText: "",
        reminderDialogSecondaryButtonLink: "",
    },
    failedPaymentFlow: {
        title: "",
        message: "",
        retryPaymentButtonLabel: "",
    },
    contactConfig: {
        differentRecipientDisabled: false,
        populatedPhoneInput: false,
    },
    discountDisclaimer: {
        enabled: false,
        enabledWhenZeroValueDeposit: false,
        disclaimerMessage: "",
        warningMessage: "",
    },
    ageVerificationPopup: {
        description: "",
        successMessage: "",
        popupMode: false,
    },
    ageVerificationMethodImages: {
        international_passport: "",
        passport: "",
        driving_license: "",
    },
    taxInfo: undefined,
    deliveryOptions: [],
    orderSummaryConfig: {
        displayItemsSummary: true,
        displayShippingAddress: true,
        displayDeliveryMethod: true,
        displayBillingAddress: true,
        displayPaymentMethod: true,
        displayLoyaltyConfirmation: true,
        displayAdditionalInfo: true,
        additionalInfo: {
            title: "",
            message: "",
        },
        displaySocialMedia: true,
        socialMediaTitle: "Follow us on",
        socialMedia: [],
    },
    consentReminderPopup: {
        consentReminderPopupEnabled: false,
        maximumOccurancesPerYear: 0,
        consentExpirationLimit: 0,
        popUpDelay: 0,
        offerConsentName: "",
        productInformationConsentName: "",
        ploomClubConsentName: "",
        mainImage: "",
        imageAltText: "",
        subtitle: "",
        mainQuestion: "",
        description: "",
        yesButtonText: "",
        noButtonText: "",
        yesRedirectUrl: "",
    },
});
export const CheckoutConfigurationProvider = ({ children, data }) => {
    const value = {
        ...data,
        deliveryOptions: data.deliveryOptions || [],
    };
    return _jsx(CheckoutConfigurationContext.Provider, { value: value, children: children });
};
//# sourceMappingURL=CheckoutConfigurationProvider.js.map